import React from 'react';
import { IndexRoute, Route } from 'react-router';
import ProfileForm from './profileForm';

export default (
  <Route path="profile">
    <IndexRoute component={props => <ProfileForm {...props} />} />
  </Route>
);
